// extracted by mini-css-extract-plugin
export default {"banner":"Banner_banner__J8oBL","content":"Banner_content__dOueh","title":"Banner_title__ZbZUa","text":"Banner_text__6zUTS"};